import Styled from 'styled-components/macro';

export const ProjectContact = Styled.div`
		.person-initials-hexagon-shape {
			z-index: 0;
		}
`;
